<div class="component-container">
  <div
    class="row w-full flex flex-col md:flex-row md:space-x-[2rem] justify-center items-center">
    <app-dropdown
      class="input md:w-[25%] min-w-[25%] w-full"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['role']"
      [options]="roleFilterList"
      [enableMultiple]="true"
      [enableClearSelection]="true"
      controlName="role"
      label="Role"
      placeholder="Select one"
      type="small"
    />
    <app-dropdown
      class="input md:w-[25%] min-w-[25%] w-full"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['status']"
      [options]="statusFilterList"
      [enableMultiple]="true"
      [enableClearSelection]="true"
      controlName="status"
      label="Status"
      placeholder="Select one"
      type="small"
    />

    <div class="vertical hidden md:block"></div>

    <app-text-input
      class="input w-full md:w-[25%] min-w-[25%] search-input"
      [parentFormGroup]="form"
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['searchText']"
      (handleSuffixClick)="apply()"
      suffixIcon="search"
      controlName="searchText"
      label="Search"
      placeholder="Search by name"
      type="small"
      [minLength]="0"
    ></app-text-input>

    <div class="vertical hidden md:block"></div>

    <app-primary-button
      type="small"
      class="btn lg:w-[10%] md:w-[10%] w-full md:mt-[2rem] mb-[2rem] mb:mb-0"
      (handleClick)="apply()"
      [isDisabled]="!form.dirty"
    >
      Apply
    </app-primary-button>
  </div>
</div>
